module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 34
// module chunks = 0